(() => {
  const initJournalLoop = (section) => {
    if (!section) return;
    const rail = section.querySelector('[data-sp-journal-featured]');
    if (!rail || rail.dataset.spLoopReady === 'true') return;

    const originals = Array.from(rail.children).filter((node) =>
      node.classList && node.classList.contains('sp-journal-featured__card')
    );

    if (originals.length < 2) return;
    rail.dataset.spLoopReady = 'true';

    const firstClone = originals[0].cloneNode(true);
    const lastClone = originals[originals.length - 1].cloneNode(true);

    [firstClone, lastClone].forEach((clone) => {
      clone.dataset.spJournalClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
    });

    rail.insertBefore(lastClone, originals[0]);
    rail.appendChild(firstClone);

    const realCount = originals.length;
    let currentIndex = 1;
    let settleTimer;
    let resizeTimer;

    const cards = () => Array.from(rail.children).filter((node) =>
      node.classList && node.classList.contains('sp-journal-featured__card')
    );

    const cardLeft = (card) => {
      const railRect = rail.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      return cardRect.left - railRect.left + rail.scrollLeft;
    };

    const centerCard = (index, behavior = 'auto') => {
      const items = cards();
      const card = items[index];
      if (!card) return;
      const left = cardLeft(card) - ((rail.clientWidth - card.getBoundingClientRect().width) / 2);
      rail.scrollTo({ left, behavior });
    };

    const settle = () => {
      const items = cards();
      if (!items.length) return;

      const viewportCenter = rail.scrollLeft + rail.clientWidth / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((card, index) => {
        const center = cardLeft(card) + card.getBoundingClientRect().width / 2;
        const distance = Math.abs(center - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      currentIndex = closestIndex;

      if (closestIndex === 0) {
        currentIndex = realCount;
        centerCard(realCount, 'auto');
      } else if (closestIndex === realCount + 1) {
        currentIndex = 1;
        centerCard(1, 'auto');
      }
    };

    rail.addEventListener('scroll', () => {
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(settle, 220);
    }, { passive: true });

    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => centerCard(currentIndex, 'auto'), 120);
    });

    requestAnimationFrame(() => {
      requestAnimationFrame(() => centerCard(1, 'auto'));
    });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('.sp-journal').forEach(initJournalLoop);
    if (root.classList && root.classList.contains('sp-journal')) initJournalLoop(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
